import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface RemoveFromGroupModalProps {
  onSubmit: () => void
  onClose: () => void
}

const RemoveFromGroupModal = ({ onSubmit, onClose }: RemoveFromGroupModalProps) => {
  const handleSubmit = () => {
    onClose()
    onSubmit()
  }

  return (
    <Modal
      title={i18n.t('expenses_v2.list.actions.modal.remove_from_group_v2.title')}
      description={i18n.t('expenses_v2.list.actions.modal.remove_from_group_v2.description')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('expenses_v2.buttons.cancel')}
          </Button>
          <Button onClick={handleSubmit}>{i18n.t('expenses_v2.buttons.remove')}</Button>
        </>
      }
      onClose={onClose}
      illustration="alert"
    />
  )
}

export default RemoveFromGroupModal
